'use client';

import { ActiveAudioItemProvider, AudioPlayer } from 'components';
import type { SearchResult } from 'conversational-search-client';
import type { JSX } from 'react';

import { AudioResultCard } from './AudioResultCard';

interface AudioResultsGridProps {
    audioItems?: SearchResult[];
}

export function AudioResultsGrid({ audioItems }: AudioResultsGridProps): JSX.Element {
    const items = audioItems ?? [];

    return (
        <ActiveAudioItemProvider>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 p-4">
                {items.map((result) => (
                    <AudioResultCard key={result.contentId} result={result} />
                ))}
            </div>
            <AudioPlayer />
        </ActiveAudioItemProvider>
    );
}
